// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Smooth Scroll */
html {
  scroll-behavior: smooth;
}

/* Error Popup Styles */
.Pricing_errorPopup__dJQaE {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  animation: Pricing_slideIn__eZkg3 0.3s ease-out;
  max-width: 400px;
}

@keyframes Pricing_slideIn__eZkg3 {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.Pricing_errorPopupContent__WeHvC {
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.Pricing_errorIcon__2NiRl {
  font-size: 20px;
}

.Pricing_errorMessage__UMhhN {
  flex: 1 1;
  color: #991b1b;
  font-size: 14px;
  line-height: 1.5;
}

.Pricing_errorCloseBtn__oM6Ay {
  background: none;
  border: none;
  color: #991b1b;
  font-size: 24px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.Pricing_errorCloseBtn__oM6Ay:hover {
  opacity: 1;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .Pricing_errorPopup__dJQaE {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
  }
  
  .Pricing_errorPopupContent__WeHvC {
    padding: 12px 16px;
  }
}


/* Promo Code Styles */
.Pricing_promoCodeSection__mciiZ {
  margin: 1rem 0;
  padding: 0.5rem;
  border-top: 1px dashed #e5e7eb;
  border-bottom: 1px dashed #e5e7eb;
}

.Pricing_promoInputGroup__yfdE6 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Pricing_promoInputWrapper__l9Iq8 {
  display: flex;
  gap: 0.5rem;
}

.Pricing_promoInput__ctqMF {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.9rem;
  text-transform: uppercase;
}

.Pricing_promoInput__ctqMF:focus {
  outline: none;
  border-color: #4d6bdf;
  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.1);
}

.Pricing_applyPromoBtn__aUuCi {
  padding: 0.5rem 1rem;
  background-color: #4d6bdf;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.Pricing_applyPromoBtn__aUuCi:hover:not(:disabled) {
  background-color: #3a56c5;
}

.Pricing_applyPromoBtn__aUuCi:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.Pricing_showPromoBtn__SiWX5 {
  background: none;
  border: none;
  color: #4d6bdf;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.5rem;
}

.Pricing_showPromoBtn__SiWX5:hover {
  color: #3a56c5;
}

.Pricing_cancelPromoBtn__ek\\+Pu {
  background: none;
  border: none;
  color: #6b7280;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.8rem;
  align-self: flex-start;
}

.Pricing_promoError__IwoYZ {
  color: #dc2626;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

.Pricing_appliedPromo__6VefC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e6f7e6;
  border: 1px solid #4caf50;
  border-radius: 4px;
  padding: 0.5rem;
}

.Pricing_promoSuccess__EssFL {
  color: #2e7d32;
  font-size: 0.9rem;
  flex: 1 1;
}

.Pricing_removePromoBtn__twm6\\+ {
  background: none;
  border: 1px solid #dc2626;
  color: #dc2626;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s;
}

.Pricing_removePromoBtn__twm6\\+:hover {
  background-color: #dc2626;
  color: white;
}

/* Price with promo styles */
.Pricing_priceWithPromo__i0UEf {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.Pricing_originalPrice__QfilN {
  text-decoration: line-through;
  color: #9ca3af;
  font-size: 0.9rem;
}

.Pricing_discountedPrice__q4nsr {
  color: #059669;
  font-weight: bold;
  font-size: 1.2rem;
}

/* Highlight for plans with active promo */
.Pricing_planCard__9kZ1P.Pricing_hasPromo__wwYfu {
  border: 2px solid #4caf50;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
}


/* International Welcome Banner */
.Pricing_internationalWelcome__uL2xM {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 2px solid #4d6bdf;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin: 1.5rem 0;
}

.Pricing_welcomeContent__QRTqF {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.Pricing_welcomeContent__QRTqF .Pricing_flag__ID9nY {
  font-size: 1.5rem;
}

.Pricing_welcomeContent__QRTqF h4 {
  margin: 0 0 0.5rem 0;
  color: #1d4ed8;
}

.Pricing_welcomeContent__QRTqF p {
  margin: 0;
  color: #374151;
  font-size: 0.95rem;
}

.Pricing_welcomeContent__QRTqF a {
  color: #4d6bdf;
  text-decoration: underline;
}

/* USD Conversion Display */
.Pricing_usdConversion__71z1W {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 4px solid #4d6bdf;
}

.Pricing_usdPrice__RgrjU {
  font-size: 1.25rem;
  font-weight: 700;
  color: #059669;
  display: block;
}

.Pricing_conversionNote__TmCx5 {
  font-size: 0.85rem;
  color: #6b7280;
  display: block;
  margin-top: 0.25rem;
}

/* International Notice Box */
.Pricing_internationalNotice__mbIUX {
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}

.Pricing_noticeHeader__7Sudb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #92400e;
}

.Pricing_noticeIcon__LnUby {
  font-size: 1.2rem;
}

.Pricing_noticePoints__xjf0n {
  margin: 0;
  padding-left: 1.5rem;
  color: #92400e;
}

.Pricing_noticePoints__xjf0n li {
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

/* FAQ Section */
.Pricing_faqSection__7KyRR {
  margin: 4rem 0;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 12px;
}

.Pricing_faqSection__7KyRR h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #1f2937;
  font-size: 1.75rem;
}

.Pricing_faqGrid__ZHQiS {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.Pricing_faqItem__ZWh0p {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.Pricing_faqItem__ZWh0p h4 {
  margin: 0 0 0.75rem 0;
  color: #1d4ed8;
  font-size: 1.1rem;
}

.Pricing_faqItem__ZWh0p p {
  margin: 0;
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.5;
}

.Pricing_faqItem__ZWh0p a {
  color: #4d6bdf;
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .Pricing_internationalWelcome__uL2xM {
    padding: 1rem;
  }
  
  .Pricing_welcomeContent__QRTqF {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .Pricing_faqGrid__ZHQiS {
    grid-template-columns: 1fr;
  }
  
  .Pricing_faqSection__7KyRR {
    padding: 1.5rem;
    margin: 2rem 0;
  }
}



/* Payment Method Selector */
.Pricing_paymentMethodSelector__rk8hi {
  text-align: center;
  margin: 2rem 0;
  padding: 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
}

.Pricing_paymentMethodSelector__rk8hi h3 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: white;
}

.Pricing_paymentMethodButtons__b1y2B {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.Pricing_paymentMethodButton__lev1c {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: white;
  border: 2px solid transparent;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.Pricing_paymentMethodButton__lev1c:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.Pricing_activePaymentMethod__uS7j4 {
  border-color: #4d6bdf;
  background: #f0f4ff;
  box-shadow: 0 0 0 3px rgba(77, 107, 223, 0.2);
}

.Pricing_paymentMethodIcon__xpHeK {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .Pricing_paymentMethodButtons__b1y2B {
    flex-direction: column;
    align-items: center;
  }
  
  .Pricing_paymentMethodButton__lev1c {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}

/* Page Container */
.Pricing_pricing3Page__5HzqV {
  min-height: 100vh;
  padding: 2rem 1rem;
  box-sizing: border-box;
  /* overflow-x: hidden; */
  max-width: 1260px;
  margin: 0 auto;
  /* overflow: auto; */
}

.Pricing_curPlan_savCal_warp__g6HCA {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
.Pricing_currentPlanContent__EUMxK {
  /* font-weight: 600; */
  background: linear-gradient(-90deg, #ffffff 0%, #cfc0f7 100% 100%);
  color: rgb(12, 11, 11);
  padding: 1rem;
  border-radius: 8px;
}

.Pricing_currentPlanLabel__AwRwX {
  color: #0369a1;
  font-size: 0.95rem;
}

.Pricing_currentPlanName__qv4IK {
  background-color: transparent;
  color: #9517ff;
  padding: 8px 12px;
  border-radius: 24px;
  max-width: 75%;
  word-wrap: break-word;
  margin-right: 6px;
  font-size: 0.95rem;
  border: 2px solid var(--secondary-color);
  font-weight: 600;
}

.Pricing_planCard__9kZ1P.Pricing_currentPlan__J9HTM {
  border: 3px solid var(--secondary-color);
  position: relative;
}

.Pricing_currentBadge__YmYN7 {
  background: var(--secondary-color);
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  position: absolute;
  top: -0.5rem;
  left: -1rem;
  transform: rotate(-11deg);
}

/* Button States */
.Pricing_currentPlanButton__9Pbku {
  background: #6b7280 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.Pricing_currentPlanButton__9Pbku:hover {
  transform: none !important;
  box-shadow: none !important;
}

.Pricing_disabledButton__Z7yy9 {
  background: #9ca3af !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.Pricing_disabledButton__Z7yy9:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Loading spinner */
.Pricing_loadingSpinner__uTQL2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.Pricing_loadingSpinner__uTQL2::after {
  content: "";
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #4d6bdf;
  border-radius: 50%;
  animation: Pricing_spin__-eDFk 1s linear infinite;
}

@keyframes Pricing_spin__-eDFk {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Heading */
.Pricing_headingWrapper__90PQm {
  text-align: center;
  margin: 2rem auto;
  max-width: 800px;
}

.Pricing_headingWrapper__90PQm h1 {
  font-size: 3rem;
  color: #1f2937;
  margin: 2rem 0 1rem 0;
  font-weight: 700;
}

.Pricing_headingWrapper__90PQm p {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 1rem 0 2rem 0;
  line-height: 1.6;
}

/* Value Banner */
.Pricing_valueBanner__dD8vP {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 3rem 0;
  flex-wrap: wrap;
}

.Pricing_valueItem__rVl7V {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.Pricing_valueIcon__AxtN- {
  font-size: 1.5rem;
}

/* Tabs */
.Pricing_tabsContainer__ntJGm {
  display: flex;
  justify-content: center;
  margin: 3rem 0 2rem;
  gap: 1rem;
}

.Pricing_tabButton__F0kHh {
  background: #fff;
  border: 2px solid #e5e7eb;
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  cursor: pointer;
  color: #4b5563;
  border-radius: 30px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Pricing_activeTabButton__KocYU {
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);
}

.Pricing_saveBadge__p0LgY {
  background-color: var(--secondary-color);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  margin-left: 0.5rem;
  font-weight: 600;
}

.Pricing_savingsCalculator__iKIYZ {
  text-align: center;
  padding: 1rem;
  background: linear-gradient(90deg, #ffffff 0%, #cfc0f7 100% 100%);
  border-radius: 8px;
  max-width: 400px;
}
.Pricing_savingsCalculator__iKIYZ strong {
  background-color: transparent;
  color: var(--secondary-color);
  padding: 8px 12px;
  border-radius: 24px;
  max-width: 75%;
  word-wrap: break-word;
  border: 2px solid var(--secondary-color);
}

.Pricing_savingsCalculator__iKIYZ p {
  /* background: #d1fae5;
  color: #065f46;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  margin: 0; */
  margin: 0;
  color: #0369a1;
  font-size: 0.95rem;
}

/* Plans */
.Pricing_plansContainer__R-zur {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 3rem auto;
  max-width: 1400px;
  flex-wrap: wrap;
}

.Pricing_planCard__9kZ1P {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 20px;
  padding: 2.5rem;
  width: 380px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: visible;
  transition: all 0.3s ease;
}

.Pricing_planCard__9kZ1P:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.Pricing_planHeader__I9WaX {
  margin-bottom: 1.5rem;
  position: relative;
}

.Pricing_planTitle__TEJ\\+3 {
  font-size: 1.8rem;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
}

.Pricing_planSubheading__SO9ft {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0 0 1.5rem 0;
  font-weight: 500;
}

/* Badges */
.Pricing_popularBadge__jyCGz,
.Pricing_valueBadge__0gr0r {
  color: white;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  position: absolute;
  top: -0.5rem;
  right: -1rem;
  transform: rotate(3deg);
}

.Pricing_popularBadge__jyCGz {
  background: var(--primary-gradient);
}

.Pricing_valueBadge__0gr0r {
  background: #60a5fa;
}

/* Plan Prices */
.Pricing_planPrice__e8OYP {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1f2937;
  margin: 1.5rem 0 0.5rem 0;
}

.Pricing_valuePerUser__BvVNy {
  font-size: 0.9rem;
  color: #10b981;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
}

.Pricing_planDescription__kuC5F {
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.5;
  margin: 1rem 0 1.5rem 0;
}

/* User Limit Section */
.Pricing_userLimitSection__zwMJt {
  margin: 1rem 0;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.Pricing_userLimitLabel__vG3GU {
  display: block;
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.Pricing_sliderContainer__NCgKr {
  position: relative;
  margin: 1.5rem 0;
}

.Pricing_userLimitSlider__b0asF {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  outline: none;
  /* -webkit-appearance: none; */
  background: #e5e7eb !important;
  cursor: pointer;
}

.Pricing_userLimitSlider__b0asF::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4d6bdf;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.Pricing_userLimitSlider__b0asF::-moz-range-thumb {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4d6bdf;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.Pricing_sliderMarkers__rjqDO {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.Pricing_marker__mCoo5 {
  font-size: 0.75rem;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 8px;
  flex: 1 1;
  margin: 0 1px;
  font-weight: 500;
  text-align: center;
}

.Pricing_marker__mCoo5:hover {
  background: #f3f4f6;
  color: #374151;
}

.Pricing_activeMarker__FDEyy {
  background: #4d6bdf;
  color: white;
  font-weight: 600;
}

/* Feature List */
.Pricing_planFeatures__8FWjS {
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  text-align: left;
}

.Pricing_planFeatures__8FWjS li {
  margin: 0.8rem 0;
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  color: #374151;
  line-height: 1.4;
}

.Pricing_planFeatures__8FWjS li::before {
  content: "✔";
  color: #10b981;
  font-size: 1rem;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

/* Buttons */
.Pricing_planButton__\\+eGRe {
  background: linear-gradient(to right, #99e9a5, #4d6bdf);
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
  font-weight: 600;
  width: 100%;
  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);
}

.Pricing_planButton__\\+eGRe:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(77, 107, 223, 0.4);
}

/* Social Proof */
.Pricing_socialProof__mKT5T {
  text-align: center;
  margin: 4rem auto;
  padding: 3rem;
  background: white;
  border-radius: 20px;
  max-width: 800px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.Pricing_socialProof__mKT5T h3 {
  font-size: 1.8rem;
  color: #1f2937;
  margin-bottom: 2rem;
  font-weight: 700;
}

.Pricing_testimonials__rKu04 {
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
}

.Pricing_testimonial__pjH0g {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 12px;
  font-style: italic;
  color: #4b5563;
  max-width: 300px;
  border-left: 4px solid #4d6bdf;
}

/* See All Button */
.Pricing_seeAllButtonWrapper__Z7sUm {
  text-align: center;
  margin: 3rem 0;
}

.Pricing_seeAllButtonWrapper__Z7sUm button {
  background: var(--primary-gradient);
  color: white;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);
}

.Pricing_seeAllButtonWrapper__Z7sUm button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(77, 107, 223, 0.4);
}

/* Responsive */
@media screen and (min-width: 1068px) and (max-width: 1440px) {
  .Pricing_plansContainer__R-zur {
    max-width: 1000px;
  }
  .Pricing_planCard__9kZ1P {
    width: 350px;
  }
    /* .plansContainer .planCard:last-child {
    width: 100%;
    max-width: 95%;
  } */
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  .Pricing_pricing3Page__5HzqV {
    padding: 1rem;
  }

  .Pricing_headingWrapper__90PQm h1 {
    font-size: 2.2rem;
  }

  .Pricing_valueBanner__dD8vP {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .Pricing_tabsContainer__ntJGm {
    width: 100%;
    /* max-width: 400px; */
  }
  .Pricing_planCard__9kZ1P {
    width: 100%;
    max-width: 325px;
  }
  .Pricing_testimonials__rKu04 {
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 668px) and (max-width: 767px)  {
  .Pricing_pricing3Page__5HzqV {
    padding: 1rem;
  }

  .Pricing_headingWrapper__90PQm h1 {
    font-size: 2.2rem;
  }

  .Pricing_valueBanner__dD8vP {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .Pricing_tabsContainer__ntJGm {
    width: 100%;
    /* max-width: 400px; */
  }
  .Pricing_planCard__9kZ1P {
    width: 100%;
    max-width: 300px;
  }
  .Pricing_plansContainer__R-zur .Pricing_planCard__9kZ1P:last-child {
    width: 100%;
    max-width: 95%;
  }

  .Pricing_testimonials__rKu04 {
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 468px) and (max-width: 667px)  {
  .Pricing_pricing3Page__5HzqV {
    padding: 1rem;
  }

  .Pricing_headingWrapper__90PQm h1 {
    font-size: 2.2rem;
  }

  .Pricing_valueBanner__dD8vP {
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .Pricing_tabsContainer__ntJGm {
    width: 100%;
    /* max-width: 400px; */
  }
  .Pricing_planCard__9kZ1P {
    width: 100%;
    max-width: 100%;
  }
  .Pricing_plansContainer__R-zur .Pricing_planCard__9kZ1P:last-child {
    width: 100%;
    max-width: 95%;
  }

  .Pricing_testimonials__rKu04 {
    flex-direction: column;
    align-items: center;
  }
}



/* Add to your Pricing.module.css */

/* Plan-specific styles */
.Pricing_planCard__9kZ1P.Pricing_scale__kMRUu {
  border: 2px solid #059669;
  position: relative;
}

.Pricing_planCard__9kZ1P.Pricing_enterprise__n3kz8 {
  border: 2px solid #7c3aed;
  background: linear-gradient(135deg, #faf5ff 0%, #f0f9ff 100%);
  position: relative;
}

.Pricing_planCard__9kZ1P.Pricing_enterprise__n3kz8::before {
  content: "🏢";
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2rem;
  opacity: 0.1;
}

/* Message limit section */
.Pricing_messageLimitSection__Qn9UD {
  margin: 1rem 0;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.Pricing_messageLimitLabel__Jemc4 {
  display: block;
  font-weight: 600;
  color: #374151;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.Pricing_messageLimitSlider__YZItX {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  outline: none;
  background: #e5e7eb !important;
  cursor: pointer;
}

.Pricing_messageLimitSlider__YZItX::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4d6bdf;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.Pricing_messageLimitSlider__YZItX::-moz-range-thumb {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #4d6bdf;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/Component/Pricing.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,+CAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA,sBAAsB;AACtB;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;;AAGA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;;;AAIA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,iDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;;;;;cAKY;EACZ,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,WAAW;AACX;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,uDAAuD;EACvD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;IACE;;;KAGC;AACL;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;;;AAIA,mCAAmC;;AAEnC,yBAAyB;AACzB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C","sourcesContent":["/* Global Smooth Scroll */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Error Popup Styles */\n.errorPopup {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  animation: slideIn 0.3s ease-out;\n  max-width: 400px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.errorPopupContent {\n  background-color: #fee2e2;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.errorIcon {\n  font-size: 20px;\n}\n\n.errorMessage {\n  flex: 1;\n  color: #991b1b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.errorCloseBtn {\n  background: none;\n  border: none;\n  color: #991b1b;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.errorCloseBtn:hover {\n  opacity: 1;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .errorPopup {\n    top: 10px;\n    right: 10px;\n    left: 10px;\n    max-width: none;\n  }\n  \n  .errorPopupContent {\n    padding: 12px 16px;\n  }\n}\n\n\n/* Promo Code Styles */\n.promoCodeSection {\n  margin: 1rem 0;\n  padding: 0.5rem;\n  border-top: 1px dashed #e5e7eb;\n  border-bottom: 1px dashed #e5e7eb;\n}\n\n.promoInputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.promoInputWrapper {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.promoInput {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n}\n\n.promoInput:focus {\n  outline: none;\n  border-color: #4d6bdf;\n  box-shadow: 0 0 0 2px rgba(77, 107, 223, 0.1);\n}\n\n.applyPromoBtn {\n  padding: 0.5rem 1rem;\n  background-color: #4d6bdf;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.applyPromoBtn:hover:not(:disabled) {\n  background-color: #3a56c5;\n}\n\n.applyPromoBtn:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.showPromoBtn {\n  background: none;\n  border: none;\n  color: #4d6bdf;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.9rem;\n  padding: 0.5rem;\n}\n\n.showPromoBtn:hover {\n  color: #3a56c5;\n}\n\n.cancelPromoBtn {\n  background: none;\n  border: none;\n  color: #6b7280;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.8rem;\n  align-self: flex-start;\n}\n\n.promoError {\n  color: #dc2626;\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n}\n\n.appliedPromo {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #e6f7e6;\n  border: 1px solid #4caf50;\n  border-radius: 4px;\n  padding: 0.5rem;\n}\n\n.promoSuccess {\n  color: #2e7d32;\n  font-size: 0.9rem;\n  flex: 1;\n}\n\n.removePromoBtn {\n  background: none;\n  border: 1px solid #dc2626;\n  color: #dc2626;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: all 0.2s;\n}\n\n.removePromoBtn:hover {\n  background-color: #dc2626;\n  color: white;\n}\n\n/* Price with promo styles */\n.priceWithPromo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.originalPrice {\n  text-decoration: line-through;\n  color: #9ca3af;\n  font-size: 0.9rem;\n}\n\n.discountedPrice {\n  color: #059669;\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n\n/* Highlight for plans with active promo */\n.planCard.hasPromo {\n  border: 2px solid #4caf50;\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);\n}\n\n\n/* International Welcome Banner */\n.internationalWelcome {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 2px solid #4d6bdf;\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  margin: 1.5rem 0;\n}\n\n.welcomeContent {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.welcomeContent .flag {\n  font-size: 1.5rem;\n}\n\n.welcomeContent h4 {\n  margin: 0 0 0.5rem 0;\n  color: #1d4ed8;\n}\n\n.welcomeContent p {\n  margin: 0;\n  color: #374151;\n  font-size: 0.95rem;\n}\n\n.welcomeContent a {\n  color: #4d6bdf;\n  text-decoration: underline;\n}\n\n/* USD Conversion Display */\n.usdConversion {\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  background: #f8fafc;\n  border-radius: 6px;\n  border-left: 4px solid #4d6bdf;\n}\n\n.usdPrice {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #059669;\n  display: block;\n}\n\n.conversionNote {\n  font-size: 0.85rem;\n  color: #6b7280;\n  display: block;\n  margin-top: 0.25rem;\n}\n\n/* International Notice Box */\n.internationalNotice {\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  padding: 1rem;\n  margin: 1rem 0;\n}\n\n.noticeHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.noticeIcon {\n  font-size: 1.2rem;\n}\n\n.noticePoints {\n  margin: 0;\n  padding-left: 1.5rem;\n  color: #92400e;\n}\n\n.noticePoints li {\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n}\n\n/* FAQ Section */\n.faqSection {\n  margin: 4rem 0;\n  padding: 2rem;\n  background: #f9fafb;\n  border-radius: 12px;\n}\n\n.faqSection h3 {\n  text-align: center;\n  margin-bottom: 2rem;\n  color: #1f2937;\n  font-size: 1.75rem;\n}\n\n.faqGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.faqItem {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.faqItem h4 {\n  margin: 0 0 0.75rem 0;\n  color: #1d4ed8;\n  font-size: 1.1rem;\n}\n\n.faqItem p {\n  margin: 0;\n  color: #4b5563;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.faqItem a {\n  color: #4d6bdf;\n  text-decoration: underline;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .internationalWelcome {\n    padding: 1rem;\n  }\n  \n  .welcomeContent {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .faqGrid {\n    grid-template-columns: 1fr;\n  }\n  \n  .faqSection {\n    padding: 1.5rem;\n    margin: 2rem 0;\n  }\n}\n\n\n\n/* Payment Method Selector */\n.paymentMethodSelector {\n  text-align: center;\n  margin: 2rem 0;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  color: white;\n}\n\n.paymentMethodSelector h3 {\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n  color: white;\n}\n\n.paymentMethodButtons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.paymentMethodButton {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 2rem;\n  background: white;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.paymentMethodButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.activePaymentMethod {\n  border-color: #4d6bdf;\n  background: #f0f4ff;\n  box-shadow: 0 0 0 3px rgba(77, 107, 223, 0.2);\n}\n\n.paymentMethodIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .paymentMethodButtons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .paymentMethodButton {\n    width: 100%;\n    max-width: 300px;\n    justify-content: center;\n  }\n}\n\n/* Page Container */\n.pricing3Page {\n  min-height: 100vh;\n  padding: 2rem 1rem;\n  box-sizing: border-box;\n  /* overflow-x: hidden; */\n  max-width: 1260px;\n  margin: 0 auto;\n  /* overflow: auto; */\n}\n\n.curPlan_savCal_warp {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n.currentPlanContent {\n  /* font-weight: 600; */\n  background: linear-gradient(-90deg, #ffffff 0%, #cfc0f7 100% 100%);\n  color: rgb(12, 11, 11);\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.currentPlanLabel {\n  color: #0369a1;\n  font-size: 0.95rem;\n}\n\n.currentPlanName {\n  background-color: transparent;\n  color: #9517ff;\n  padding: 8px 12px;\n  border-radius: 24px;\n  max-width: 75%;\n  word-wrap: break-word;\n  margin-right: 6px;\n  font-size: 0.95rem;\n  border: 2px solid var(--secondary-color);\n  font-weight: 600;\n}\n\n.planCard.currentPlan {\n  border: 3px solid var(--secondary-color);\n  position: relative;\n}\n\n.currentBadge {\n  background: var(--secondary-color);\n  color: white;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  position: absolute;\n  top: -0.5rem;\n  left: -1rem;\n  transform: rotate(-11deg);\n}\n\n/* Button States */\n.currentPlanButton {\n  background: #6b7280 !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.currentPlanButton:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.disabledButton {\n  background: #9ca3af !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.disabledButton:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Loading spinner */\n.loadingSpinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n.loadingSpinner::after {\n  content: \"\";\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top: 4px solid #4d6bdf;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Heading */\n.headingWrapper {\n  text-align: center;\n  margin: 2rem auto;\n  max-width: 800px;\n}\n\n.headingWrapper h1 {\n  font-size: 3rem;\n  color: #1f2937;\n  margin: 2rem 0 1rem 0;\n  font-weight: 700;\n}\n\n.headingWrapper p {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 1rem 0 2rem 0;\n  line-height: 1.6;\n}\n\n/* Value Banner */\n.valueBanner {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin: 3rem 0;\n  flex-wrap: wrap;\n}\n\n.valueItem {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  background: white;\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #374151;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.valueIcon {\n  font-size: 1.5rem;\n}\n\n/* Tabs */\n.tabsContainer {\n  display: flex;\n  justify-content: center;\n  margin: 3rem 0 2rem;\n  gap: 1rem;\n}\n\n.tabButton {\n  background: #fff;\n  border: 2px solid #e5e7eb;\n  padding: 0.8rem 2rem;\n  font-size: 1.1rem;\n  cursor: pointer;\n  color: #4b5563;\n  border-radius: 30px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.activeTabButton {\n  background: var(--primary-gradient);\n  color: white;\n  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);\n}\n\n.saveBadge {\n  background-color: var(--secondary-color);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  margin-left: 0.5rem;\n  font-weight: 600;\n}\n\n.savingsCalculator {\n  text-align: center;\n  padding: 1rem;\n  background: linear-gradient(90deg, #ffffff 0%, #cfc0f7 100% 100%);\n  border-radius: 8px;\n  max-width: 400px;\n}\n.savingsCalculator strong {\n  background-color: transparent;\n  color: var(--secondary-color);\n  padding: 8px 12px;\n  border-radius: 24px;\n  max-width: 75%;\n  word-wrap: break-word;\n  border: 2px solid var(--secondary-color);\n}\n\n.savingsCalculator p {\n  /* background: #d1fae5;\n  color: #065f46;\n  padding: 0.8rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  margin: 0; */\n  margin: 0;\n  color: #0369a1;\n  font-size: 0.95rem;\n}\n\n/* Plans */\n.plansContainer {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin: 3rem auto;\n  max-width: 1400px;\n  flex-wrap: wrap;\n}\n\n.planCard {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 20px;\n  padding: 2.5rem;\n  width: 380px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: visible;\n  transition: all 0.3s ease;\n}\n\n.planCard:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.planHeader {\n  margin-bottom: 1.5rem;\n  position: relative;\n}\n\n.planTitle {\n  font-size: 1.8rem;\n  color: #1f2937;\n  margin: 0 0 0.5rem 0;\n  font-weight: 700;\n}\n\n.planSubheading {\n  color: #6b7280;\n  font-size: 0.9rem;\n  margin: 0 0 1.5rem 0;\n  font-weight: 500;\n}\n\n/* Badges */\n.popularBadge,\n.valueBadge {\n  color: white;\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  position: absolute;\n  top: -0.5rem;\n  right: -1rem;\n  transform: rotate(3deg);\n}\n\n.popularBadge {\n  background: var(--primary-gradient);\n}\n\n.valueBadge {\n  background: #60a5fa;\n}\n\n/* Plan Prices */\n.planPrice {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #1f2937;\n  margin: 1.5rem 0 0.5rem 0;\n}\n\n.valuePerUser {\n  font-size: 0.9rem;\n  color: #10b981;\n  font-weight: 600;\n  margin: 0 0 1.5rem 0;\n}\n\n.planDescription {\n  color: #6b7280;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 1rem 0 1.5rem 0;\n}\n\n/* User Limit Section */\n.userLimitSection {\n  margin: 1rem 0;\n  padding: 1.5rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.userLimitLabel {\n  display: block;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.sliderContainer {\n  position: relative;\n  margin: 1.5rem 0;\n}\n\n.userLimitSlider {\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  outline: none;\n  /* -webkit-appearance: none; */\n  background: #e5e7eb !important;\n  cursor: pointer;\n}\n\n.userLimitSlider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #4d6bdf;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: all 0.2s ease;\n}\n\n.userLimitSlider::-moz-range-thumb {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #4d6bdf;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.sliderMarkers {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n.marker {\n  font-size: 0.75rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 8px;\n  flex: 1;\n  margin: 0 1px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.marker:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.activeMarker {\n  background: #4d6bdf;\n  color: white;\n  font-weight: 600;\n}\n\n/* Feature List */\n.planFeatures {\n  list-style: none;\n  padding: 0;\n  margin: 2rem 0;\n  text-align: left;\n}\n\n.planFeatures li {\n  margin: 0.8rem 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.planFeatures li::before {\n  content: \"✔\";\n  color: #10b981;\n  font-size: 1rem;\n  font-weight: bold;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n/* Buttons */\n.planButton {\n  background: linear-gradient(to right, #99e9a5, #4d6bdf);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  font-weight: 600;\n  width: 100%;\n  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);\n}\n\n.planButton:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(77, 107, 223, 0.4);\n}\n\n/* Social Proof */\n.socialProof {\n  text-align: center;\n  margin: 4rem auto;\n  padding: 3rem;\n  background: white;\n  border-radius: 20px;\n  max-width: 800px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.socialProof h3 {\n  font-size: 1.8rem;\n  color: #1f2937;\n  margin-bottom: 2rem;\n  font-weight: 700;\n}\n\n.testimonials {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.testimonial {\n  background: #f8fafc;\n  padding: 1.5rem;\n  border-radius: 12px;\n  font-style: italic;\n  color: #4b5563;\n  max-width: 300px;\n  border-left: 4px solid #4d6bdf;\n}\n\n/* See All Button */\n.seeAllButtonWrapper {\n  text-align: center;\n  margin: 3rem 0;\n}\n\n.seeAllButtonWrapper button {\n  background: var(--primary-gradient);\n  color: white;\n  border: none;\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(77, 107, 223, 0.3);\n}\n\n.seeAllButtonWrapper button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(77, 107, 223, 0.4);\n}\n\n/* Responsive */\n@media screen and (min-width: 1068px) and (max-width: 1440px) {\n  .plansContainer {\n    max-width: 1000px;\n  }\n  .planCard {\n    width: 350px;\n  }\n    /* .plansContainer .planCard:last-child {\n    width: 100%;\n    max-width: 95%;\n  } */\n}\n\n@media screen and (min-width: 768px) and (max-width: 1067px) {\n  .pricing3Page {\n    padding: 1rem;\n  }\n\n  .headingWrapper h1 {\n    font-size: 2.2rem;\n  }\n\n  .valueBanner {\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .tabsContainer {\n    width: 100%;\n    /* max-width: 400px; */\n  }\n  .planCard {\n    width: 100%;\n    max-width: 325px;\n  }\n  .testimonials {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media screen and (min-width: 668px) and (max-width: 767px)  {\n  .pricing3Page {\n    padding: 1rem;\n  }\n\n  .headingWrapper h1 {\n    font-size: 2.2rem;\n  }\n\n  .valueBanner {\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .tabsContainer {\n    width: 100%;\n    /* max-width: 400px; */\n  }\n  .planCard {\n    width: 100%;\n    max-width: 300px;\n  }\n  .plansContainer .planCard:last-child {\n    width: 100%;\n    max-width: 95%;\n  }\n\n  .testimonials {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media screen and (min-width: 468px) and (max-width: 667px)  {\n  .pricing3Page {\n    padding: 1rem;\n  }\n\n  .headingWrapper h1 {\n    font-size: 2.2rem;\n  }\n\n  .valueBanner {\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .tabsContainer {\n    width: 100%;\n    /* max-width: 400px; */\n  }\n  .planCard {\n    width: 100%;\n    max-width: 100%;\n  }\n  .plansContainer .planCard:last-child {\n    width: 100%;\n    max-width: 95%;\n  }\n\n  .testimonials {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n\n\n/* Add to your Pricing.module.css */\n\n/* Plan-specific styles */\n.planCard.scale {\n  border: 2px solid #059669;\n  position: relative;\n}\n\n.planCard.enterprise {\n  border: 2px solid #7c3aed;\n  background: linear-gradient(135deg, #faf5ff 0%, #f0f9ff 100%);\n  position: relative;\n}\n\n.planCard.enterprise::before {\n  content: \"🏢\";\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  font-size: 2rem;\n  opacity: 0.1;\n}\n\n/* Message limit section */\n.messageLimitSection {\n  margin: 1rem 0;\n  padding: 1.5rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.messageLimitLabel {\n  display: block;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.messageLimitSlider {\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  outline: none;\n  background: #e5e7eb !important;\n  cursor: pointer;\n}\n\n.messageLimitSlider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #4d6bdf;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: all 0.2s ease;\n}\n\n.messageLimitSlider::-moz-range-thumb {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #4d6bdf;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPopup": `Pricing_errorPopup__dJQaE`,
	"slideIn": `Pricing_slideIn__eZkg3`,
	"errorPopupContent": `Pricing_errorPopupContent__WeHvC`,
	"errorIcon": `Pricing_errorIcon__2NiRl`,
	"errorMessage": `Pricing_errorMessage__UMhhN`,
	"errorCloseBtn": `Pricing_errorCloseBtn__oM6Ay`,
	"promoCodeSection": `Pricing_promoCodeSection__mciiZ`,
	"promoInputGroup": `Pricing_promoInputGroup__yfdE6`,
	"promoInputWrapper": `Pricing_promoInputWrapper__l9Iq8`,
	"promoInput": `Pricing_promoInput__ctqMF`,
	"applyPromoBtn": `Pricing_applyPromoBtn__aUuCi`,
	"showPromoBtn": `Pricing_showPromoBtn__SiWX5`,
	"cancelPromoBtn": `Pricing_cancelPromoBtn__ek+Pu`,
	"promoError": `Pricing_promoError__IwoYZ`,
	"appliedPromo": `Pricing_appliedPromo__6VefC`,
	"promoSuccess": `Pricing_promoSuccess__EssFL`,
	"removePromoBtn": `Pricing_removePromoBtn__twm6+`,
	"priceWithPromo": `Pricing_priceWithPromo__i0UEf`,
	"originalPrice": `Pricing_originalPrice__QfilN`,
	"discountedPrice": `Pricing_discountedPrice__q4nsr`,
	"planCard": `Pricing_planCard__9kZ1P`,
	"hasPromo": `Pricing_hasPromo__wwYfu`,
	"internationalWelcome": `Pricing_internationalWelcome__uL2xM`,
	"welcomeContent": `Pricing_welcomeContent__QRTqF`,
	"flag": `Pricing_flag__ID9nY`,
	"usdConversion": `Pricing_usdConversion__71z1W`,
	"usdPrice": `Pricing_usdPrice__RgrjU`,
	"conversionNote": `Pricing_conversionNote__TmCx5`,
	"internationalNotice": `Pricing_internationalNotice__mbIUX`,
	"noticeHeader": `Pricing_noticeHeader__7Sudb`,
	"noticeIcon": `Pricing_noticeIcon__LnUby`,
	"noticePoints": `Pricing_noticePoints__xjf0n`,
	"faqSection": `Pricing_faqSection__7KyRR`,
	"faqGrid": `Pricing_faqGrid__ZHQiS`,
	"faqItem": `Pricing_faqItem__ZWh0p`,
	"paymentMethodSelector": `Pricing_paymentMethodSelector__rk8hi`,
	"paymentMethodButtons": `Pricing_paymentMethodButtons__b1y2B`,
	"paymentMethodButton": `Pricing_paymentMethodButton__lev1c`,
	"activePaymentMethod": `Pricing_activePaymentMethod__uS7j4`,
	"paymentMethodIcon": `Pricing_paymentMethodIcon__xpHeK`,
	"pricing3Page": `Pricing_pricing3Page__5HzqV`,
	"curPlan_savCal_warp": `Pricing_curPlan_savCal_warp__g6HCA`,
	"currentPlanContent": `Pricing_currentPlanContent__EUMxK`,
	"currentPlanLabel": `Pricing_currentPlanLabel__AwRwX`,
	"currentPlanName": `Pricing_currentPlanName__qv4IK`,
	"currentPlan": `Pricing_currentPlan__J9HTM`,
	"currentBadge": `Pricing_currentBadge__YmYN7`,
	"currentPlanButton": `Pricing_currentPlanButton__9Pbku`,
	"disabledButton": `Pricing_disabledButton__Z7yy9`,
	"loadingSpinner": `Pricing_loadingSpinner__uTQL2`,
	"spin": `Pricing_spin__-eDFk`,
	"headingWrapper": `Pricing_headingWrapper__90PQm`,
	"valueBanner": `Pricing_valueBanner__dD8vP`,
	"valueItem": `Pricing_valueItem__rVl7V`,
	"valueIcon": `Pricing_valueIcon__AxtN-`,
	"tabsContainer": `Pricing_tabsContainer__ntJGm`,
	"tabButton": `Pricing_tabButton__F0kHh`,
	"activeTabButton": `Pricing_activeTabButton__KocYU`,
	"saveBadge": `Pricing_saveBadge__p0LgY`,
	"savingsCalculator": `Pricing_savingsCalculator__iKIYZ`,
	"plansContainer": `Pricing_plansContainer__R-zur`,
	"planHeader": `Pricing_planHeader__I9WaX`,
	"planTitle": `Pricing_planTitle__TEJ+3`,
	"planSubheading": `Pricing_planSubheading__SO9ft`,
	"popularBadge": `Pricing_popularBadge__jyCGz`,
	"valueBadge": `Pricing_valueBadge__0gr0r`,
	"planPrice": `Pricing_planPrice__e8OYP`,
	"valuePerUser": `Pricing_valuePerUser__BvVNy`,
	"planDescription": `Pricing_planDescription__kuC5F`,
	"userLimitSection": `Pricing_userLimitSection__zwMJt`,
	"userLimitLabel": `Pricing_userLimitLabel__vG3GU`,
	"sliderContainer": `Pricing_sliderContainer__NCgKr`,
	"userLimitSlider": `Pricing_userLimitSlider__b0asF`,
	"sliderMarkers": `Pricing_sliderMarkers__rjqDO`,
	"marker": `Pricing_marker__mCoo5`,
	"activeMarker": `Pricing_activeMarker__FDEyy`,
	"planFeatures": `Pricing_planFeatures__8FWjS`,
	"planButton": `Pricing_planButton__+eGRe`,
	"socialProof": `Pricing_socialProof__mKT5T`,
	"testimonials": `Pricing_testimonials__rKu04`,
	"testimonial": `Pricing_testimonial__pjH0g`,
	"seeAllButtonWrapper": `Pricing_seeAllButtonWrapper__Z7sUm`,
	"scale": `Pricing_scale__kMRUu`,
	"enterprise": `Pricing_enterprise__n3kz8`,
	"messageLimitSection": `Pricing_messageLimitSection__Qn9UD`,
	"messageLimitLabel": `Pricing_messageLimitLabel__Jemc4`,
	"messageLimitSlider": `Pricing_messageLimitSlider__YZItX`
};
export default ___CSS_LOADER_EXPORT___;
